import React, { memo } from "react";
import { TableCell, TableRow, Typography } from "@mui/material";

function LinhaVazia() {
  return (
    <TableRow>
      <TableCell colSpan={6}>
        <Typography
          variant="body2"
          sx={{ textAlign: "center", py: 1.5, color: "#666" }}
        >
          Nenhuma nota fiscal encontrada para o periodo selecionado.
        </Typography>
      </TableCell>
    </TableRow>
  );
}

export default memo(LinhaVazia);
